// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import DTHRecharge from "../DTHRecharge";
// import MobileRecharge from "../PrepaidMobile/MobileRecharge";
// import Electricity from "../Electricity";
// import Fastag from "../Fastag/Fastag";
// import LpgBooking from "../LpgBooking/LpgBooking";
// import Inactive from "../../components/Inactive";
// const serviceComponentMap = {
//   dth: DTHRecharge,
//   recharge: MobileRecharge,
//   electricity: Electricity,
//   fastag: Fastag,
//   lpg: LpgBooking,
// };
// const DynamicService = () => {
//   const { slug } = useParams();
//   const Component = serviceComponentMap[slug];
//   if (!Component) {
//     return <Inactive message="Service Coming Soon" />;
//   }
//   return <Component />;
// };
// export default DynamicService;




import React from "react";
import { useParams, Navigate } from "react-router-dom";
import DTHRecharge from "../DTHRecharge";
import MobileRecharge from "../PrepaidMobile/MobileRecharge";
import Electricity from "../Electricity";
import Fastag from "../Fastag/Fastag";
import LpgBooking from "../LpgBooking/LpgBooking";
import PgPayoutSelect from "../Finkeda/PgPayoutSelect";
import CreditCardSelect from "../CreditCardSelect";

const serviceComponentMap = {
  dth: DTHRecharge,
  recharge: MobileRecharge,
  electricity: Electricity,
  fastag: Fastag,
  lpg: LpgBooking,
  matm: PgPayoutSelect,
  ccbp: CreditCardSelect,
};

const DynamicService = () => {
  const { slug } = useParams();

  const Component = serviceComponentMap[slug];

  // ✅ agar slug 5 me se nahi hai
  if (!Component) {
    return <Navigate to="/new-payment" replace />;
  }

  return <Component />;
};

export default DynamicService;

